// extracted by mini-css-extract-plugin
module.exports = {"viewDetailsBtn":"HRNotifications_viewDetailsBtn__NcG7s"};